import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";
import type { Playbook } from "../../../shared/types";

// ── Queries ──

export function usePlaybooks() {
  return useQuery({
    queryKey: ["playbooks"],
    queryFn: () => api.get<{ data: Playbook[] }>("/api/playbooks"),
  });
}

// ── Mutations ──

export function useActivatePlaybook() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (payload: { playbookId: string; brand_id: string }) =>
      api.post<{
        data: {
          playbook_id: string;
          brand_id: string;
          scheduled_runs: number;
          steps: { day: number; checkin_id: string; delay_seconds: number }[];
        };
      }>(`/api/playbooks/${payload.playbookId}/activate`, {
        brand_id: payload.brand_id,
      }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["playbooks"] });
      qc.invalidateQueries({ queryKey: ["content-runs"] });
    },
  });
}
